import type React from 'react';
import { useEffect, useRef } from 'react';

/**
 * A ref that tracks whether the component is currently mounted, for guarding work that resumes
 * after an await.
 *
 * The effect sets it back to `true` on every mount, not just the first: StrictMode's development
 * mount → cleanup → remount would otherwise latch it `false` and silently kill every continuation.
 */
export function useIsMountedRef(): React.RefObject<boolean> {
	const isMountedRef = useRef(true);

	useEffect(() => {
		isMountedRef.current = true;

		return () => {
			isMountedRef.current = false;
		};
	}, []);

	return isMountedRef;
}
